import Utils from '../util/Utils.jsx';
import { getOfflineDatasetInfo } from './db.js';
import { parseLayoutFilter, withValidLayoutGrouping } from '../context/projectLayout.js';
import { getDevMockDatasetInfo, getDevMockDatasets, shouldUseDevMockProjects, withDevTimeout } from '../util/devMockProjects.js';

const wbsListDefaults = {
	ViewType: 'WBS List',
	GroupBy: null,
	GroupByActivityCode: null
};

const restoreLayouts = (result, layoutId) => {
	let lastLayout = false;
	const layouts = Array.isArray(result.layouts) ? result.layouts : [];
	for (const layout of layouts) {
		layout.Filter = parseLayoutFilter(layout.Filter);
		if (layout.Id === layoutId || (!layoutId && layout.LastUsed === '1')) {
			lastLayout = JSON.parse(JSON.stringify(layout));
		}
	}
	if (lastLayout) {
		lastLayout = withValidLayoutGrouping(lastLayout, result.activityCodesTree);
	}
	return {
		...result,
		layouts,
		...(lastLayout || wbsListDefaults)
	};
};

export const mergeDatasetInfoExtras = (dataset, infoResult) => {
	if (!dataset || !infoResult) {
		return dataset;
	}
	const next = { ...dataset };
	if (infoResult.calendars) {
		next.calendars = infoResult.calendars;
	}
	if (infoResult.baselineByTask) {
		next.baselineByTask = infoResult.baselineByTask;
	}
	return next;
};

export const getDatasetInfo = (dispatch, datasetId, layoutId = false) => {
	if (shouldUseDevMockProjects() && getDevMockDatasets()[String(datasetId)]) {
		return withDevTimeout(Utils.ajaxAsync('getDatasetInfo', { dataset: datasetId }, null, { suppressErrorAlert: true }))
			.then(result => {
				if (result.success) {
					try {
						return restoreLayouts(result, layoutId);
					} catch {
						return { ...result, ...wbsListDefaults };
					}
				}
				return getDevMockDatasetInfo(datasetId);
			})
			.catch(() => getDevMockDatasetInfo(datasetId));
	}

	if (Utils.isOnline()) {
		return Utils.ajaxAsync('getDatasetInfo', { dataset: datasetId }, dispatch).then(result => {
			if (!result || !result.success) {
				return Promise.reject(result || { success: false });
			}
			try {
				return restoreLayouts(result, layoutId);
			} catch {
				return {
					...result,
					...wbsListDefaults
				};
			}
		});
	}
	return getOfflineDatasetInfo(dispatch, datasetId, layoutId);
};
